import { defineStore } from 'pinia';
import api from '../../api';
import { useNetworksStore } from './networks';

export const useNeighborStore = defineStore('neighbor', {
  state: () => ({
    neighborList : [],
    neighborListUpdated: false,
    loadingNeighborList: false,
  }),

  actions: {
    queryNeighbor(params) {
      if (this.loadingNeighborList) return;
      this.loadingNeighborList = true;
      return api.neighbor.queryNeighbor(params)
        .then(json => {
          let dataSource = [];
          if (json.resp.respCode === 0) {
            let { rows } = json.lldpRemoteDevice;
            if (rows.length) {
              dataSource = rows.map(item => {
                if (!item.remotePortId) item.remotePortId = '';
                return item;
              });
            }
          } else {
            // this.$sakura.sakuraMessage(json.resp.respCode);
          }
          this.setNeighborList(dataSource);
          return json;
        })
        .catch(error => {
          throw error;
        })
        .finally(() => {
          this.loadingNeighborList = false;
        });
    },
    setNeighborList(data){
      this.neighborList = data;
      const networksStore = useNetworksStore();
      networksStore.setNeighborList(data);
      this.neighborListUpdated = true;
    },
    setLldpRemoteDevice(data) {
      let dataSource = [];
      let { rows } = data;
      if (rows.length) {
        dataSource = rows.map(item => {
          if (!item.remotePortId) item.remotePortId = '';
          return item;
        });
      }
      this.setNeighborList(dataSource);
    }
  }
});
